<template>
  <div class="general-List">
    <van-list :loading="loading" v-if="list.length > 0" :finished="finished"
              finished-text="没有更多了"
              @load="onLoad" class="cons-list">
      <div class="items-blocks" :class="item.isQuality ? 'isQuality':''" v-for="(item, index) in list" :key="index">
        <ListItem :item="item" :user-info="userInfo" :cur-tab-key="curTabKey"/>
      </div>
      <!-- 自定义加载结束内容 -->
      <template #finished>
        <div class="custom-finished">
          <div class="none-txt">没有更多了! <br/>您可以在“智能助手”查看更多哦~</div>
          <div class="none-btn" @click="$emit('viewMore')">
            智能助手
            <img src="../../../assets/images/person/right2.png" class="icon-arrow" alt="">
          </div>
        </div>
      </template>
    </van-list>
    <div class="search-none" v-else-if="searchValue && list.length <= 0">
      <img src="../../../assets/images/home/empty_state_none@2x.png" class="none-img" alt="">
      <div class="none-txt">
        <span v-if="isHaveRedirect">基础搜索功能无法找到内容，<br/>已为您自动跳转至“智能助手”查看更多哦</span>
        <span v-else>暂无数据</span>
      </div>
    </div>
  </div>
</template>

<script>
import {homeSearch} from '../../../api/api'
import ListItem from './ListItem.vue'
import {handleTraceSearchLog} from '../../../utils/trace'

export default {
  components: {ListItem},
  props: ['userInfo', 'searchValue', 'curTabKey', 'curTabType'],
  data() {
    return {
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      list: [],
      isHaveRedirect: false,
      searchSeq: 0,
      redirectTimer: null
    }
  },
  beforeDestroy() {
    this.clearRedirectTimer()
  },
  methods: {
    clearRedirectTimer() {
      if (this.redirectTimer) {
        clearTimeout(this.redirectTimer)
        this.redirectTimer = null
      }
    },
    resetData() {
      this.searchSeq += 1
      this.clearRedirectTimer()
      this.list = []
      this.pageNum = 1
      this.finished = false
      this.loading = false
      this.isHaveRedirect = false
    },
    async onLoad(options) {
      if (this.loading) {
        return
      }
      const loop = !!(options && options.loop)
      const redirectAi = !!(options && options.redirectAi)
      const seq = this.searchSeq
      // course_section_name 帖子类型1发帖2投票3直播预告4代办任务（作业）
      // course_type 类别1RTC2图文专区3心电图交流
      // section_id 专区ID
      this.loading = true
      this.isHaveRedirect = false
      try {
        const res = await homeSearch({
          'userId': this.userInfo.id,
          'searchContent': this.searchValue,
          'sessionId': localStorage.getItem('sessionId'),
          'type': this.curTabType, // 1文献解读 2课程 3病例 4帖子 5视频 6PPT 7文献 8图文
          'pageNum': this.pageNum,
          'pageSize': this.pageSize,
          'homeType': 1,
          'queryType': 2
        })
        if (seq !== this.searchSeq) return
        sessionStorage.setItem('searchParams', JSON.stringify({
          searchContent: this.searchValue,
          curTabType: this.curTabType,
          curTabKey: this.curTabKey
        }))
        this.loading = false
        if (this.pageNum === 1) {
          this.handleTraceSearch('1', '请求成功')
        }
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.list)
        this.pageNum++
        // 加载状态结束
        if (this.list.length <= 0 && loop) {
          this.checkAndSwitchToAvailableTab(redirectAi, seq)
        }
      } catch (e) {
        if (seq !== this.searchSeq) return
        this.handleTraceSearch('1', '请求失败')
      }
    },
    async checkAndSwitchToAvailableTab(redirectAi, seq) {
      // 定义需要检查的tab类型顺序（包括当前tab）
      const tabTypesToCheck = ['2', '3', '1', '7', '5', '6', '8', '4']

      // 依次检查所有tab
      for (const type of tabTypesToCheck) {
        // 跳过当前tab，因为我们已经知道它没有数据
        if (type === `${this.curTabType}`) continue
        if (seq !== this.searchSeq) return

        const {hasData, list} = await this.checkTabHasDataWithResult(type)
        if (seq !== this.searchSeq) return
        if (hasData) {
          this.$emit('update:curTabType', type)
          this.list = list
          this.pageNum = 2
          this.finished = list.length < this.pageSize
          sessionStorage.setItem('searchParams', JSON.stringify({
            searchContent: this.searchValue,
            curTabType: type,
            curTabKey: this.curTabKey
          }))
          return
        }
      }

      if (seq !== this.searchSeq || !redirectAi) return
      // 提交搜索且其他tab都没有数据时，跳转到智能搜索
      this.isHaveRedirect = true
      this.clearRedirectTimer()
      this.redirectTimer = setTimeout(() => {
        if (seq !== this.searchSeq) return
        this.$emit('viewMore')
      }, 1500)
    },
    async checkTabHasDataWithResult(tabType) {
      const params = {
        'userId': this.userInfo.id,
        'searchContent': this.searchValue,
        'sessionId': localStorage.getItem('sessionId'),
        'type': tabType, // 1文献解读 2课程 3病例 4帖子 5视频 6PPT 7文献 8图文
        'pageNum': 1,
        'pageSize': this.pageSize,
        'homeType': 1,
        'queryType': 2
      }

      try {
        const res = await homeSearch(params)
        const data = res.data || {}
        const list = data.list || []
        return {
          hasData: list.length > 0,
          list,
        }
      } catch (err) {
        console.error(`检查 tabType=${tabType} 是否有数据失败:`, err)
        return {hasData: false}
      }
    },
    handleTraceSearch(type, tip) {
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': `${tip}-${this.searchValue}`,
        'sessionId': localStorage.getItem('sessionId'),
        'type': type, // '1: ‘搜索‘， 2: ’智能',
        'entrance': 5
      })
    },
  }
}
</script>

<style scoped lang="less">
.general-List {
  margin-top: 10px;
}

.custom-finished {
  margin-top: 50px;

  .custom-txt {
    line-height: 24px;

    .txt-col {
      color: #EB1700;
    }
  }
}

.search-none {
  .none-img {
    width: 185px;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 50px;
  }

  .none-txt {
    font-family: PingFang HK, PingFang HK;
    font-size: 12px;
    color: #949BA5;
    text-align: center;
    margin-top: 10px;

    &.ai-none-txt {
      width: 294px;
      margin-left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
    }

    .txt-col {
      color: #EB1700;
    }
  }
}

.none-txt {
  line-height: 24px;
}

.none-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 25px;
  font-family: PingFang HK, PingFang HK;
  color: #FFFFFF;
  font-size: 14px;
  background-color: #EB1700;
  border-radius: 100px;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 10px;

  .icon-arrow {
    width: 12px;
    margin-left: 2px;
  }
}

.cons-list {
  padding: 0 16px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/generalList.vue